import { styled } from 'styletron-react';
import { rhythm } from '../../utils/typography';

export const BlogHeader = styled('h1', {
  marginBottom: rhythm(1 / 8),
});
